/* eslint-disable react/prop-types */ // TODO: add props
import { Popover } from 'react-bootstrap';
import { UniqueOverlayTrigger } from 'edrolo/domains/overlays';
import BookmarkForm from '../BookmarkForm';

const ChunkBookmarkPopoverTrigger = (props) => {
  const placement =
    $(window).width() <= 480 ? props.narrowPlacement : props.placement;
  return (
    <UniqueOverlayTrigger
      trigger="click"
      placement={placement}
      rootClose
      uniqueOverlayId={`chunk-bookmark-${props.chunkId}`}
      renderOverlay={(overlayControl) => (
        <Popover id={`chunk-bookmark-${props.chunkId}`}>
          <BookmarkForm
            bookmark={props.bookmark}
            onRemove={() => {
              props.removeBookmark();
              overlayControl.hide();
            }}
            onCancel={() => {
              overlayControl.hide();
            }}
            onSave={(bookmarkData) => {
              props.saveBookmark(bookmarkData);
              overlayControl.hide();
            }}
          />
        </Popover>
      )}
    >
      {props.children}
    </UniqueOverlayTrigger>
  );
};

ChunkBookmarkPopoverTrigger.defaultProps = {
  placement: 'left',
  narrowPlacement: 'bottom',
};

export default ChunkBookmarkPopoverTrigger;
